import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/users`;

// Enregistrer un utilisateur
const saveUser = async (userData) => {
  try {
    const response = await api.post(API_URL, userData);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de l'enregistrement de l'utilisateur.");
    throw error;
  }
};

// Enregistrer une liste d'utilisateurs
export const saveListUser = async (userData) => {
  const url = `${API_URL}/list`;
  try {
    const response = await api.post(url, userData);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de l'enregistrement des utilisateurs.");
    throw error;
  }
};
export const saveAllUserCheck = async (userData,selected,selectedAuto) => {
  const url = `${API_URL}/checked/${selected}/${selectedAuto}`;

      
  try {
    const response = await api.post(url, userData);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de l'enregistrement des utilisateurs.");
    throw error;
  }
};
// Récupérer tous les utilisateurs
const getAllUser = async (page, size,disabled,filtreInclure,filtreInclureAuto,filter,
                          idServices,idDirections,idToll) => {

  try {
    const params = new URLSearchParams();
    if (page!== null && page !== undefined) params.append('page', page);
    if (size!== null && size !== undefined) params.append('size', size);
    if (disabled!== null && disabled !== undefined) params.append('disabled', disabled);
    if (filtreInclure!== null && filtreInclure !== undefined) params.append('checked', filtreInclure);
    if (filtreInclureAuto!== null && filtreInclureAuto !== undefined) params.append('checkedAuto', filtreInclureAuto);
    if (idServices!== null && idServices !== undefined) params.append('idServices', idServices);
    if (idDirections!== null && idDirections !== undefined) params.append('idDirections', idDirections);
    if (idToll!== null && idToll !== undefined) params.append('idToll', idToll);
    if (filter!== null && filter !== undefined) params.append('search', filter);
    const url = `${API_URL}?${params.toString()}`;

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des utilisateurs.");
    return [];
  }
};

export const getAllUsers = async () => {
  const url = `${API_URL}/all`;

  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des utilisateurs.");
    return [];
  }
};
const getAllDisabledUsers = async (disabled) => {
    const url = `${API_URL}/status/${disabled}`;
  

  try {
    const response = await api.get(url);
    
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des utilisateurs.");
    return [];
  }
};

export const getDisabledUsers = async (page, size,search) => {
    const url = `${API_URL}/disabled-users`;
  

  try {
    const response = await api.get(url, {
      params: { page, size,search }
    });
    
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des utilisateurs.");
    return [];
  }
};

// Récupérer un utilisateur par ID
export const getIdUsers = async (userId) => {
  const url = `${API_URL}/${userId}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération de l'utilisateur.");
    throw error;
  }
};

// Désactiver un utilisateur
export const disableUser = async (userId, userData) => {
  const url = `${API_URL}/disable/${userId}`;
  try {
    const response = await api.put(url, userData);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la désactivation de l'utilisateur.");
    throw error;
  }
};

// Mettre à jour un utilisateur
export const updateUsers = async (userId, userData) => {
  const url = `${API_URL}/${userId}`;
  try {
    const response = await api.put(url, userData);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la mise à jour de l'utilisateur.");
    throw error;
  }
};
export const updateUsersReminderBlocklist = async ( userData) => {
  const url = `${API_URL}/update-reminder-blocklist`;
  try {
    const response = await api.put(url, userData);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la mise à jour de l'utilisateur.");
    throw error;
  }
};

// Supprimer un utilisateur
export const deleteUsers = async (userId) => {
  const url = `${API_URL}/${userId}`;
  try {
    const response = await api.delete(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la suppression de l'utilisateur.");
    throw error;
  }
};

export const getCountUsers = async () => {
  const url = `${API_URL}/dashboard`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération de l'utilisateur.");
    throw error;
  }

};

export const getUsersWithoutObjective = async (page, size, year, filter) => {

  const url = `${API_URL}/users-without-objective`;
  try {
    const response = await api.get(url, {
      params: {page, size, year, search: filter ?? ""}
    });

    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération de l'utilisateur.");
    throw error;
  }

};

export const getUsersWithoutEvaluation = async (page, size, year, filter,isAuto) => {
  const url = `${API_URL}/users-without-evaluation`;
  try {
    const response = await api.get(url, {
      params: {
        page,
        size,
        year,
        isAuto: isAuto ?? false,
        search: filter ?? ""}
    });    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération de l'utilisateur.");
    throw error;
  }

};

export const saveAllUserCheckObj = async (allSelected,disabled,filter) => {
  const url = `${API_URL}/all/obj`;

  try {
    const response = await api.get(url, {
      params: {
        selected: allSelected ?? false,
        disabled: disabled ?? false,
        search: filter ?? ""
      },
    });
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des utilisateurs.");
    return [];
  }
};
export const saveAllUserCheckAuto = async (allSelectedAutoEvaluation,disabled,filter) => {
  const url = `${API_URL}/all/auto`;

  try {
    const response = await api.get(url, {
      params: {
        selectedAuto: allSelectedAutoEvaluation ?? false,
        disabled: disabled ?? false,
        search: filter ?? ""
      },
    });
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des utilisateurs.");
    return [];
  }
};

export const updateObjectifChecked = async (id,checked) => {
  const url = `${API_URL}/checked/auto/${id}/${checked}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des utilisateurs.");
    return [];
  }
};
export const updateAutoEvaluationChecked = async (id,checkedAuto) => {
  const url = `${API_URL}/checked/eval/${id}/${checkedAuto}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des utilisateurs.");
    return [];
  }
};

export { saveUser, getAllUser,getAllDisabledUsers };
